export enum UserType {
    Guest = "guest",
    User = "user"
}